import React from "react";
import "./InjuryModal.css";

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export default function InjuryModal({ 
  homeInjuries, 
  awayInjuries, 
  homeTeam, 
  awayTeam, 
  homeTeamId,
  awayTeamId,
  userTeamId,
  homeTheme, 
  awayTheme, 
  onClose,
  reportSetting = "yourTeam"
}) {
  // Filter to only valid injury objects
  const validHomeInjuries = (homeInjuries || []).filter(i => i && i.playerId && i.playerName);
  const validAwayInjuries = (awayInjuries || []).filter(i => i && i.playerId && i.playerName);
  
  // Don't render if no valid injuries at all
  if (!validHomeInjuries.length && !validAwayInjuries.length) {
    return null;
  }

  // Determine if user is home or away team
  const isUserHome = userTeamId === homeTeamId;
  
  // Get user's team info and injuries
  const userTeam = isUserHome ? homeTeam : awayTeam;
  const userInjuries = isUserHome ? validHomeInjuries : validAwayInjuries;
  const userTheme = isUserHome ? homeTheme : awayTheme;
  
  // Get opponent's team info and injuries
  const opponentTeam = isUserHome ? awayTeam : homeTeam;
  const opponentInjuries = isUserHome ? validAwayInjuries : validHomeInjuries;
  const opponentTheme = isUserHome ? awayTheme : homeTheme;

  return (
    <div className="injury-modal-overlay" onClick={onClose}>
      <div className="injury-modal" onClick={(e) => e.stopPropagation()}>
        <div className="injury-modal-header">
          <h2>Injury Report</h2>
          <button className="injury-modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="injury-modal-content">
          {/* User Team Injuries */}
          <div className="injury-team-section">
            <div 
              className="injury-team-header"
              style={{ 
                background: `linear-gradient(135deg, ${userTheme?.colors?.primary || userTheme?.primary || "#1252d2"}, ${userTheme?.colors?.secondary || userTheme?.secondary || "#386eda"})`
              }}
            >
              <h3>{userTeam} Injuries</h3>
            </div>
            <div className="injury-team-list">
              {userInjuries && userInjuries.length > 0 ? (
                userInjuries.map((inj, idx) => (
                  <div key={idx} className="injury-item">
                    <div className="injury-item-left">
                      <span className="injury-player-name">{inj.playerName}</span>
                      <span className="injury-type">{inj.injury}</span>
                    </div>
                    <span className="injury-duration">
                      Out {inj.gamesOut} game{inj.gamesOut !== 1 ? "s" : ""}
                    </span>
                  </div>
                ))
              ) : (
                <div className="injury-none">No injuries this game.</div>
              )}
            </div>
          </div>

          {/* Opponent Team Injuries (only if "bothTeams" setting) */}
          {reportSetting === "bothTeams" && (
            <div className="injury-team-section">
              <div 
                className="injury-team-header"
                style={{ 
                  background: `linear-gradient(135deg, ${opponentTheme?.colors?.primary || opponentTheme?.primary || "#1252d2"}, ${opponentTheme?.colors?.secondary || opponentTheme?.secondary || "#386eda"})`
                }}
              >
                <h3>{opponentTeam} Injuries</h3>
              </div>
              <div className="injury-team-list">
                {opponentInjuries && opponentInjuries.length > 0 ? (
                  opponentInjuries.map((inj, idx) => (
                    <div key={idx} className="injury-item">
                      <div className="injury-item-left">
                        <span className="injury-player-name">{inj.playerName}</span>
                        <span className="injury-type">{inj.injury}</span>
                      </div>
                      <span className="injury-duration">
                        Out {inj.gamesOut} game{inj.gamesOut !== 1 ? "s" : ""}
                      </span>
                    </div>
                  ))
                ) : (
                  <div className="injury-none">No injuries this game.</div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="injury-modal-footer">
          <button className="injury-modal-btn" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
